import { cva as o, ct as n } from "@/styled-system/css";
const r = o({
  base: {
    flex: "0 0 auto",
    marginInlineEnd: n("Banner.spacing.gap.leading")
  },
  variants: {
    tone: {
      critical: { color: n("Banner.colors.critical.icon") },
      info: { color: n("Banner.colors.info.icon") },
      success: { color: n("Banner.colors.success.icon") },
      warning: { color: n("Banner.colors.warning.icon") }
    }
  }
});
export {
  r as bannerIconRecipe
};
//# sourceMappingURL=banner-icon.styles.js.map
